/*global google*/

import React from "react";
import ReactDOM from "react-dom";

import _ from 'lodash';

class GoogleMap extends React.Component {

  map = null;
  mapRef = null;
  searchBoxRef = null;
  defaultPolygonInst = null;
  defaultPolygon = null;
  selectedPolygon = null;

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.defaultPolygon !== undefined && nextProps.defaultPolygon !== null) {
      if (this.defaultPolygonInst !== null) {
        this.defaultPolygonInst.setMap(null);
      }

      this.defaultPolygonInst = new google.maps.Polygon({
        paths: this.formatMongoToGooglePaths(nextProps.defaultPolygon),
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.25,
        editable: nextProps.defaultPolygonEditable
          ? nextProps.defaultPolygonEditable
          : false
      });
      this.addPolygonEvents(this.defaultPolygonInst);
      this.defaultPolygonInst.setMap(this.map);

      if (!_.isEqual(this.defaultPolygon, nextProps.defaultPolygon)) {
        let defaultPolygonCenter = this.getPolygonCenter(nextProps.defaultPolygon);
        this.map.setCenter(new google.maps.LatLng(defaultPolygonCenter[1], defaultPolygonCenter[0]));
        this.map.setZoom(16);
        this.defaultPolygon = nextProps.defaultPolygon;
      }

      return true;
    }

    if ((nextProps.defaultPolygon === undefined || nextProps.defaultPolygon === null) && this.defaultPolygonInst !== null) {
      this.defaultPolygonInst.setMap(null);
      return true;
    }

    return false;
  }

  componentDidMount() {
    let initMap = {
      center: { lng: 15.3386383, lat: 49.7437572 },
      zoom: 7
    };

    if (this.props.defaultPolygon !== undefined && this.props.defaultPolygon !== null) {
      this.defaultPolygon = this.props.defaultPolygon;
    }

    if (this.props.defaultPolygon !== undefined && this.props.defaultPolygon !== null) {
      let defaultPolygonCenter = this.getPolygonCenter(this.props.defaultPolygon);
      initMap.center.lng = defaultPolygonCenter[0];
      initMap.center.lat = defaultPolygonCenter[1];
      initMap.zoom = 16;
    }

    var map = new google.maps.Map(this.mapRef, this.props.initMap || initMap);
    this.map = map;

    if (this.props.drawingManagerEnabled !== undefined && this.props.drawingManagerEnabled) {
      var centerControlDiv = document.createElement('div');
      var centerControl = this.createRemoveButton(centerControlDiv, this.map);
      centerControlDiv.index = 1;
      this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);

      var drawingManager = new google.maps.drawing.DrawingManager({
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            google.maps.drawing.OverlayType.MARKER,
            google.maps.drawing.OverlayType.POLYGON
          ]
        },
        markerOptions: {
          draggable: true
        },
        polygonOptions: {
          strokeColor: '#4249ce',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#4249ce',
          fillOpacity: 0.25,
          editable: true,
          zIndex: 1
        }
      });
      drawingManager.setMap(map);

      google.maps.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
        this.selectedPolygon = polygon;
        var coords = [];
        polygon
          .getPath()
          .getArray()
          .map(c => {
            coords.push([c.lng(), c.lat()]);
          });
        this.addPolygonEvents(polygon);
        coords.push(coords[0]);
        this.props.onPolygonChanged
          ? this.props.onPolygonChanged(coords)
          : null;
      }.bind(this));

      google.maps.event.addListener(drawingManager, 'markercomplete', function (marker) {
        this.props.onMarkerChanged !== undefined
          ? this.props.onMarkerChanged([
            marker.getPosition().lng(), 
            marker.getPosition().lat()
          ])
          : null;

        google.maps.event.addListener(marker, 'dragend', (mmarker) => {
          this.props.onMarkerChanged !== undefined
            ? this.props.onMarkerChanged([
              marker.getPosition().lng(), 
              marker.getPosition().lat()
            ])
            : null;
        });
      }.bind(this));
    }

    if (this.props.defaultPolygon !== undefined && this.props.defaultPolygon !== null) {
      this.defaultPolygonInst = new google.maps.Polygon({
        paths: this.formatMongoToGooglePaths(this.props.defaultPolygon),
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.25,
        editable: this.props.defaultPolygonEditable ? this.props.defaultPolygonEditable : false
      });
      this.addPolygonEvents(this.defaultPolygonInst);
      this.defaultPolygonInst.setMap(map);
    }
  }

  addPolygonEvents(polygon) {
    polygon.getPaths().forEach(function (path, index) {
      google.maps.event.addListener(path, 'insert_at', function () {
        // new point
        let coords = [];
        path
          .getArray()
          .map(c => {
            coords.push([c.lng(), c.lat()]);
          });
        coords.push(coords[0]);
        this.props.onPolygonChanged
          ? this.props.onPolygonChanged(coords)
          : null;
      }.bind(this));
      google.maps.event.addListener(path, 'remove_at', function () {
        // removed point
        let coords = [];
        path
          .getArray()
          .map(c => {
            coords.push([c.lng(), c.lat()]);
          });
        coords.push(coords[0]);
        this.props.onPolygonChanged
          ? this.props.onPolygonChanged(coords)
          : null;
      }.bind(this));
      google.maps.event.addListener(path, 'set_at', function () {
        // moved point
        let coords = [];
        path
          .getArray()
          .map(c => {
            coords.push([c.lng(), c.lat()]);
          });
        coords.push(coords[0]);
        this.props.onPolygonChanged
          ? this.props.onPolygonChanged(coords)
          : null;
      }.bind(this));
    }.bind(this));
  }

  createRemoveButton(controlDiv, map) {
    var controlUI = document.createElement('div');
    controlUI.style.backgroundColor = '#fff';
    controlUI.style.border = '1px solid #fff';
    controlUI.style.borderRadius = '2px';
    controlUI.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';
    controlUI.style.cursor = 'pointer';
    controlUI.style.marginTop = '5px';
    controlUI.style.textAlign = 'center';
    controlUI.title = 'Click to recenter the map';
    controlDiv.appendChild(controlUI);

    var controlText = document.createElement('div');
    controlText.style.color = 'rgb(86, 86, 86)';
    controlText.style.fontFamily = 'Roboto, Arial, sans-serif';
    controlText.style.fontSize = '11px';
    controlText.style.lineHeight = 'normal';
    controlText.style.paddingLeft = '8px';
    controlText.style.paddingRight = '8px';
    controlText.style.paddingTop = '4px';
    controlText.style.paddingBottom = '3px';
    controlText.innerHTML = '&#10006';
    controlUI.appendChild(controlText);

    controlUI.addEventListener('click', function () {
      if (this.selectedPolygon !== undefined && this.selectedPolygon !== null) {
        this.selectedPolygon.setMap(null);
        this.props.onPolygonChanged(this.defaultPolygon || null);
      }
    }.bind(this));
  }

  formatMongoToGooglePaths(paths) {
    return paths.map(path => {
      return {
        lng: path[0],
        lat: path[1]
      };
    });
  }

  getPolygonCenter(arr) {
    var minX, maxX, minY, maxY;
    for (var i = 0; i < arr.length; i++) {
      minX = (arr[i][0] < minX || minX == null) ? arr[i][0] : minX;
      maxX = (arr[i][0] > maxX || maxX == null) ? arr[i][0] : maxX;
      minY = (arr[i][1] < minY || minY == null) ? arr[i][1] : minY;
      maxY = (arr[i][1] > maxY || maxY == null) ? arr[i][1] : maxY;
    }
    return [(minX + maxX) / 2, (minY + maxY) / 2];
  }

  render() {
    return (
      <div style={this.props.style || { width: '100%', height: 400 }} ref={ref => { this.mapRef = ref }}>
        <input ref={ref => { this.searchBoxRef = ref; }} />
      </div>
    );
  }
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/GoogleMap.js